import React, {Fragment, PureComponent} from 'react';
import {connect} from 'react-redux';
import {Field, formValueSelector, reduxForm} from 'redux-form'
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';

import Input from '../../Form/Field/Input.jsx';
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';

import conf from '../../../../shared/conf.js';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';
import {generate} from '../../../routes.js';
import validate from './validate.js';
import submit from './submit.js';

import './RegisterForm.scss';

export const name = 'RegisterForm';

class RegisterForm extends PureComponent {
  static propTypes = {
    accountType: PropTypes.number.isRequired,
    universes: PropTypes.array,
    data: PropTypes.object,
  };

  static defaultProps = {
    universes: [],
    data: null
  };

  constructor(props) {
    super(props);

    props.initialize({
      main_universe: props.currentUniverseId ? props.currentUniverseId.toString() : null,
      accountType: props.accountType,
      selectedUniverse: props.selectedUniverse,
      ...props.data
    });
  }

  render() {
    return <Fragment>
      <form id={name} className="register-form" onSubmit={this.props.handleSubmit}>
        <FormGlobalErrors errors={this.props.error}/>
        <h2>Choix de votre univers</h2>
        <div className="d-flex form-group mt-3">
          <div className="universes-radio d-inline-flex" id="universes">
            {this.props.universes.map((universe, index) => (
              <Field
                key={universe.id}
                id={`${name}.universe${index}`}
                label={universe.name}
                name="main_universe"
                type="radio"
                wrapperClassName={this.props.selectedUniverse === universe.id.toString() ? 'active': ''}
                value={universe.id.toString()}
                spaceBeforeLabel={false}
                component={Input}
                errorTarget="universes"
              />
            ))}
          </div>
        </div>

        <hr className="my-4"/>

        <h2>Informations personnelles</h2>
        <Field
          label="Email*"
          name="email"
          component={Input}
          type="text"
          placeholder="john@doe.fr"
        />
        <Field
          label="Mot de passe*"
          name="plain_password"
          placeholder="Mot de passe"
          component={Input}
          type="password"
        />
        {this.props.accountType === conf.accountTypes.do ?
          <Field
            label="Numéro de téléphone*"
            name="tel"
            placeholder="+15142565657"
            component={Input}
            type="tel"
          /> : ''
        }
        <Field
          name="account_type"
          value={this.props.accountType}
          component={Input}
          type="hidden"
        />
        <div className="row">
          <div className="col-sm-12 cgu">
            <Field
              label={
                <span>
                  J'accepte <Link to={`${generate({name: 'cgu'})}`} target="_blank" rel="noopener noreferrer">
                  les conditions d'utilisation</Link> du site
                </span>
              }
              name="cgu_accepted"
              component={Input}
              type="checkbox"
            />
          </div>
        </div>
      </form>
      <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
    </Fragment>;
  }
}

const ReduxRegisterForm = reduxForm({
  form: name,
  onSubmit: submit,
  onSubmitFail: createOnSubmitFailHandler(name, false),
  validate
})(RegisterForm);

const selector = formValueSelector(name);

export default connect(
  state => ({
    currentUniverseId: state?.universe?.currentUniverse?.id ?? null,
    selectedUniverse: selector(state, 'main_universe')
  })
)(ReduxRegisterForm);
